export default __webpack_public_path__ + "static/media/footer2.f9b9abe4.jpg";